<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-windows-full-col`]" width="1em" height="1em" v-bind="$attrs"><g transform="translate(8 8)" fill="none" fill-rule="evenodd"><circle :fill="useCurrentColor ? 'currentColor' : '#F2F3F5'" cx="57" cy="57" r="57"/><path :fill="useCurrentColor ? 'currentColor' : '#6C0'" d="M25.5789474 25.5L54 25.5 54 0 25.5789474 4.06048935z" transform="translate(31 32)"/><path :fill="useCurrentColor ? 'currentColor' : '#09F'" d="M0 42.4566839L22.7368421 45.3333333 22.7368421 25.5 0 25.5z" transform="translate(31 32)"/><path :fill="useCurrentColor ? 'currentColor' : '#F63'" d="M0 22.6666667L22.7368421 22.6666667 22.7368421 2.83333333 0 5.70989793z" transform="translate(31 32)"/><path :fill="useCurrentColor ? 'currentColor' : '#FC0'" d="M25.5789474 46.9394702L54 51 54 25.5 25.5789474 25.5z" transform="translate(31 32)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmWindowsFullCol',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
